import { Column } from '@access-erp/common';
import { useMemo } from 'react';

import { browserHistory } from '@/routing/browserHistory';
import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { getHeaderColumns } from '../columns/headerColumns';

export interface UseTransactionTableColumnsReturn {
  headerColumns: Column<any>[];
  goToClientDatabasesBySearch: (searchText?: string) => void;
}

export const useColumns = (): UseTransactionTableColumnsReturn => {

  const goToClientDatabasesBySearch = (searchText?: string) => {
    const link = searchText
      ? `/client-databases?search=${encodeURIComponent(searchText)}`
      : '/client-databases';
    browserHistory.push(getParameterizedLink(link));
  };

  return useMemo(() => {
    const headerColumns = getHeaderColumns();
    return {
      headerColumns,
      goToClientDatabasesBySearch,
    };
  }, []);
};
